import ApiService from "@/common/api.service"

export const ProgramEventService = {
    create(params) {
        return ApiService.post("/events/add", params);
    },
    update(slug, params) {
        return ApiService.update("/events", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/events/delete", slug, params)
    },
    async getProgramEvents(params = {}) {
        const queryParts = [];
        if (params.startDate) {
            queryParts.push(`startDate=${encodeURIComponent(params.startDate)}`);
        }
        if (params.endDate) {
            queryParts.push(`endDate=${encodeURIComponent(params.endDate)}`);
        }
        if (params.regionId) {
            queryParts.push(`regionId=${encodeURIComponent(params.regionId)}`);
        }
        if (!params.startDate && !params.endDate) {
            if (params.year) {
                queryParts.push(`year=${encodeURIComponent(params.year)}`);
            }
            if (params.month) {
                queryParts.push(`month=${encodeURIComponent(params.month)}`);
            }
        }
        const query = queryParts.length ? `?${queryParts.join("&")}` : "";
        const res = await ApiService.get(`/events${query}`);
        return res.data;
    },
    async getEventByCPDActivity(cpdActivityId) {
        const res = await ApiService.get("/events/all/byCpdActivity/" + cpdActivityId);
        return res.data;
    }

}
